import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { LogIn } from "lucide-react";
import { api, formatApiError } from "../lib/api";
import { useSettings, resolveImageUrl } from "../lib/SettingsContext";

export default function AdminLogin() {
  const nav = useNavigate();
  const { settings } = useSettings();
  const logoSrc = resolveImageUrl(settings?.logo_url) || "/logo.png";
  const [form, setForm] = useState({ email: "admin@pprints.com", password: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", form);
      localStorage.setItem("pp_token", data.token);
      localStorage.setItem("pp_user", JSON.stringify(data.user));
      toast.success("Welcome back!");
      nav("/admin");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-brand-mist p-6" data-testid="admin-login">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center gap-3 mb-8 justify-center">
          <img src={logoSrc} alt="PPrints" className="h-14 w-14 rounded-full object-cover bg-white ring-1 ring-gray-200" />
          <span className="font-display font-extrabold text-xl">
            <span className="text-brand-ink">P</span><span className="text-brand-green">P</span><span className="text-brand-ink">rints</span>
            <span className="text-gray-500 text-sm font-semibold ml-1">Admin</span>
          </span>
        </Link>
        <form onSubmit={submit} className="bg-white rounded-3xl border border-gray-200 p-8 shadow-sm">
          <h1 className="font-display text-2xl font-extrabold text-brand-ink">Sign in</h1>
          <p className="text-sm text-gray-500 mt-1">Manage your inquiries and content.</p>

          <div className="mt-6 space-y-4">
            <div>
              <label className="overline text-gray-500">Email</label>
              <input
                data-testid="admin-email"
                type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })}
                className="mt-1 w-full rounded-xl border border-gray-200 px-4 py-3 focus:border-brand-blue focus:outline-none focus:ring-2 focus:ring-brand-green/30"
              />
            </div>
            <div>
              <label className="overline text-gray-500">Password</label>
              <input
                data-testid="admin-password"
                type="password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })}
                className="mt-1 w-full rounded-xl border border-gray-200 px-4 py-3 focus:border-brand-blue focus:outline-none focus:ring-2 focus:ring-brand-green/30"
              />
            </div>
            <button data-testid="admin-login-submit" disabled={loading} className="btn-primary w-full disabled:opacity-60">
              {loading ? "Signing in..." : (<><LogIn className="h-4 w-4" /> Sign in</>)}
            </button>
          </div>
        </form>
        <p className="text-center text-xs text-gray-500 mt-6">© 2026 PPrints · Admin Portal</p>
      </div>
    </div>
  );
}
